import { addClass, removeClass } from '../../assets/js/utility';

class SpotlightReel {
  constructor() {
    this.toggleClass = 'is-active';
    this.spotlightSections = document.querySelectorAll('.dynamic-spotlight-reel');
    this.activeIndex = 0;

    if (this.spotlightSections && this.spotlightSections.length > 0) {
      this.initSpotlights();
    }
  }

  /**
   * These should be reliably paired lists
   * @param {*} links
   * @param {*} images
   * @param {*} id
   */
  setActive(links, images, prevId, targetId) {
    if (prevId === targetId) {
      return targetId;
    }

    addClass(links[targetId], this.toggleClass);
    addClass(images[targetId], this.toggleClass);
    removeClass(links[prevId], this.toggleClass);
    removeClass(images[prevId], this.toggleClass);

    return targetId;
  }

  initSpotlights() {
    this.spotlightSections.forEach((section) => {
      let pageLinks = section.querySelectorAll('.page-list a');
      let bgImages = section.querySelectorAll('picture');

      if (
        !pageLinks ||
        pageLinks.length <= 0 ||
        !bgImages ||
        bgImages.length != pageLinks.length
      ) {
        return;
      }

      let activeIndex = 0;

      pageLinks.forEach((link, index) => {
        link.addEventListener('mouseenter', () => {
          activeIndex = this.setActive(pageLinks, bgImages, activeIndex, index);
        });

        link.addEventListener('focus', () => {
          activeIndex = this.setActive(pageLinks, bgImages, activeIndex, index);
        });
      });
    });
  }
}

export default SpotlightReel;
